import LibraryBooks from '@mui/icons-material/LibraryBooks';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function LibraryBooksIcon(props: FixMe) {
  return <LibraryBooks {...props} />;
}

export default LibraryBooksIcon;
